import { render, staticRenderFns } from "./UploadXml.vue?vue&type=template&id=180501e8"
import script from "./UploadXml.vue?vue&type=script&lang=js"
export * from "./UploadXml.vue?vue&type=script&lang=js"
import style0 from "./UploadXml.vue?vue&type=style&index=0&id=180501e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports